var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-footer"},[_vm._t("left"),_c('v-spacer'),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }